import React from "react";
import BingoPlayersList from "../components/BingoPlayersList";
import _ from "lodash";

function BingoCalled({
  called_bingo,
  users,
  timed,
  countdown,
  current_player_details,
  set_show_bingo_board,
  gameParams,
}) {
  const players_details = users.filter((user) => called_bingo.includes(user.player_id));
  const user_called_bingo = called_bingo.includes(current_player_details?.player_id);
  const bingo_called_params = _.get(gameParams, "4_bingocalled");
  const check_button = _.get(bingo_called_params, "check_button", "CHECK YOUR CARD");
  const label = _.get(bingo_called_params, "label", "BINGO HAS BEEN CALLED BY:");
  const timed_called = _.get(
    bingo_called_params,
    "timed_called",
    "YOU CALLED BINGO! TIME UNTIL IT IS CHECKED",
  );
  const timed_text = _.get(
    bingo_called_params,
    "timed_text",
    "CHECK YOUR CARD TO SEE IF YOU HAVE A BINGO TOO!",
  );
  const untimed_called = _.get(
    bingo_called_params,
    "untimed_called",
    "YOU CALLED BINGO! WAIT UNTIL THE HOST CHOOSES TO CHECK",
  );
  const untimed_text = _.get(
    bingo_called_params,
    "untimed_text",
    "CHECK YOUR CARD TO SEE IF YOU HAVE A BINGO TOO!",
  );

  const get_details_from_conditions = () => {
    if (timed) {
      if (user_called_bingo) {
        return (
          <>
            <h3 className="check-txt">{timed_called}</h3>
            <h4 className="number">{countdown}</h4>
          </>
        );
      } else {
        return (
          <>
            <h3 className="check-txt">{timed_text}</h3>
            <h4 className="number">{countdown}</h4>
            <button className="check-card-btn" onClick={() => set_show_bingo_board(true)}>
              {check_button}
            </button>
          </>
        );
      }
    } else {
      if (user_called_bingo) {
        return (
          <>
            <h3 className="check-txt">{untimed_called}</h3>
          </>
        );
      } else {
        return (
          <>
            <h3 className="check-txt">{untimed_text}</h3>
            <button className="check-card-btn" onClick={() => set_show_bingo_board(true)}>
              {check_button}
            </button>
          </>
        );
      }
    }
  };
  return (
    <>
      <div className="bingo-called-wrapper">
        <h2 className="called-txt">{label}</h2>
        <div className="bingo-called-users">
          <BingoPlayersList players={players_details} />
        </div>
        <div className="check-card">{get_details_from_conditions()}</div>
      </div>
    </>
  );
}

export default BingoCalled;
